// given a form whose submit button disabled,
// when changing any of the inputs, the submit
// button is enabled.
// to enable this behavior, set the disabled
// and a data-enable-on-input-change attribute on the submit button
import $ from 'jquery';

export default function enableSubmitOnInputChange() {
  $('[data-enable-on-input-change]').each(function () {
    var $submit = $(this);
    var $form = $submit.parents('form');
    $form.on('change', 'input, select, textarea', function () {
      $submit.attr('disabled', false);
    });
  });
}
